const htmlOutput = { _id: 'dt:template_output_type:html', name : 'HTML' };
const pdfOutput  = { _id: 'dt:template_output_type:pdf', name: 'PDF' };
const textOutput = { _id: 'dt:template_output_type:text', name : 'Text' };
const xmlOutput  = { _id: 'dt:template_output_type:xml', name : 'XML' };
const outputTypeList = [
  htmlOutput,
  pdfOutput,
  textOutput,
  xmlOutput,
]

module.exports = {
  textOutput,
  htmlOutput,
  xmlOutput,
  pdfOutput,
  outputTypeList
}